<main class="app-layout__page">
  <router-outlet></router-outlet>
</main>